var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"otp"}},[_vm._t("default",null,{"digits":_vm.digits,"isvalid":_vm.isValid,"onblur":_vm.onBlur,"oninput":_vm.onInput,"onpaste":_vm.onPaste}),_vm._t("error",null,{"message":_vm.errorMessage,"haserror":_vm.error})],2)}
var staticRenderFns = []

export { render, staticRenderFns }